var map = {
  "./": "6418",
  "./client": "6039",
  "./client.ts": "6039",
  "./dom/attr": "8806",
  "./dom/attr.ts": "8806",
  "./dom/beacon": "7265",
  "./dom/beacon.ts": "7265",
  "./dom/cookie": "8227",
  "./dom/cookie.ts": "8227",
  "./dom/css": "8114",
  "./dom/css.ts": "8114",
  "./dom/document": "6820",
  "./dom/document.ts": "6820",
  "./dom/element": "1733",
  "./dom/element.ts": "1733",
  "./dom/fontface": "737",
  "./dom/fontface.ts": "737",
  "./dom/fragments": "2452",
  "./dom/fragments.ts": "2452",
  "./dom/history": "4397",
  "./dom/history.ts": "4397",
  "./dom/open": "5421",
  "./dom/open.ts": "5421",
  "./dom/origin": "8703",
  "./dom/origin.ts": "8703",
  "./dom/performance": "7539",
  "./dom/performance.ts": "7539",
  "./dom/protocol": "8345",
  "./dom/protocol.ts": "8345",
  "./dom/storage": "5724",
  "./dom/storage.ts": "5724",
  "./entry": "7530",
  "./entry.ts": "7530",
  "./events": "2037",
  "./events.ts": "2037",
  "./helpers": "1171",
  "./helpers.ts": "1171",
  "./index": "6418",
  "./index.ts": "6418",
  "./location": "4239",
  "./location.ts": "4239",
  "./shared/antiantidebugger": "2115",
  "./shared/antiantidebugger.ts": "2115",
  "./shared/blob": "6495",
  "./shared/blob.ts": "6495",
  "./shared/caches": "735",
  "./shared/caches.ts": "735",
  "./shared/chrome": "7198",
  "./shared/chrome.ts": "7198",
  "./shared/err": "5241",
  "./shared/err.ts": "5241",
  "./shared/error": "6380",
  "./shared/error.ts": "6380",
  "./shared/eval": "2490",
  "./shared/eval.ts": "2490",
  "./shared/event": "1762",
  "./shared/event.ts": "1762",
  "./shared/function": "2284",
  "./shared/function.ts": "2284",
  "./shared/import": "8201",
  "./shared/import.ts": "8201",
  "./shared/indexeddb": "7309",
  "./shared/indexeddb.ts": "7309",
  "./shared/opfs": "1544",
  "./shared/opfs.ts": "1544",
  "./shared/postmessage": "6771",
  "./shared/postmessage.ts": "6771",
  "./shared/realm": "6237",
  "./shared/realm.ts": "6237",
  "./shared/requests/eventsource": "7396",
  "./shared/requests/eventsource.ts": "7396",
  "./shared/requests/fetch": "7705",
  "./shared/requests/fetch.ts": "7705",
  "./shared/requests/websocket": "3342",
  "./shared/requests/websocket.ts": "3342",
  "./shared/requests/xmlhttprequest": "5639",
  "./shared/requests/xmlhttprequest.ts": "5639",
  "./shared/settimeout": "4355",
  "./shared/settimeout.ts": "4355",
  "./shared/sourcemaps": "6666",
  "./shared/sourcemaps.ts": "6666",
  "./shared/worker": "4034",
  "./shared/worker.ts": "4034",
  "./shared/wrap": "3680",
  "./shared/wrap.ts": "3680",
  "./singletonbox": "4470",
  "./singletonbox.ts": "4470",
  "./worker/importScripts": "6722",
  "./worker/importScripts.ts": "6722"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 8770;
